import Navbar from './Navbar';
import Footer from './Footer';
import PageHero from './PageHero';
import ProductCard from './ProductCard';
import Formular from './Formular';
import { ScrollRestoration } from 'react-router-dom';
import dekorativne1416 from '../resources/Dekoračný 14-16.jpeg';
import dekorativne1622 from '../resources/Dekoračný dunaj 16-22.jpeg';
import dekorativne1632 from '../resources/Dekoračný 16-32.jpeg';
import dekorativne63120 from '../resources/Dekoračný 63-120.jpeg';

const items = [
    'Frakcia 14/16 Okrasný',
    'Frakcia 16/22 Okrasný',
    'Frakcia 16/32 Okrasný',
    'Frakcia 63/120 Okrasný',
];

const cards = [
    {
        img: dekorativne1416,
        badge: 'Dekoratívne kamenivo',
        title: 'Frakcia 14/16',
        description: 'Vhodný na výstavbu skaliek, vytváranie záhonov a skrášlenie okolia domu. Kamene nájdu uplatnenie aj okolo domu na lepší odvod dažďovej vody.',
        tableRows: [{ label: 'Cena za t', bezDph: '35,00 €', sDph: '43,05 €' }],
    },
    {
        img: dekorativne1622,
        badge: 'Dekoratívne kamenivo',
        title: 'Frakcia 16/22',
        description: 'Vhodný na výstavbu skaliek, vytváranie záhonov a skrášlenie okolia domu. Kamene nájdu uplatnenie aj okolo domu na lepší odvod dažďovej vody.',
        tableRows: [{ label: 'Cena za t', bezDph: '32,52 €', sDph: '40,00 €' }],
    },
    {
        img: dekorativne1632,
        badge: 'Dekoratívne kamenivo',
        title: 'Frakcia 16/32',
        description: 'Vhodný na výstavbu skaliek, vytváranie záhonov a skrášlenie okolia domu. Kamene nájdu uplatnenie aj okolo domu na lepší odvod dažďovej vody.',
        tableRows: [{ label: 'Cena za t', bezDph: '34,96 €', sDph: '43,00 €' }],
    },
    {
        img: dekorativne63120,
        badge: 'Dekoratívne kamenivo',
        title: 'Frakcia 63/120',
        description: 'Vhodný na výstavbu skaliek, záhonov a skrášlenie okolia domu, taktiež ako náplň do pohľadových gabiónov.',
        tableRows: [{ label: 'Cena za t', bezDph: '26,99 €', sDph: '33,20 €' }],
    },
];

function Okrasny() {
    return (
        <div>
            <Navbar />
            <PageHero
                title="Naša"
                highlight="ponuka"
                subtitle="Dekoratívne kamenivo pre záhrady, skalky a gabióny."
            />
            <div className="max-w-screen-xl mx-auto px-6 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                {cards.map((card, i) => (
                    <ProductCard key={i} {...card} />
                ))}
            </div>
            <Formular napln={items} />
            <Footer />
            <ScrollRestoration />
        </div>
    );
}

export default Okrasny;
